const Muster = require('./muster');

/**
 * Create a new Muster module
 * @returns {Muster} The Muster module
 */
function muster() {
  return new Muster();
}

module.exports = muster;
